module.exports = __webpack_public_path__ + "img/Model-R-11x5x28.063ffcaf.png";